(ns app.domain.fee.escrow-model
  (:require [app.domain.business.model :as business-model]
            [app.domain.group.model :as group-model]
            [core.db.child-entity :as child]
            [core.user.model :as user-model]
            [core.util.schemas :as schemas]
            [schema-tools.core :as st]))

(def CreateBusinessAndAccount
  (st/merge business-model/BusinessEditInfo
            {:business/invite-email schemas/Email}))

(def account-owner-types
  [:escrow-account.owner-type/business
   :escrow-account.owner-type/user])

(def ^{:arglists '([escrow-account])} account-transactions
  (child/child-entities-of-type-fn :entity.type/escrow-transaction))

(defn account-owner-name [{:escrow-account/keys [owner-type owner] :as account} lang]
  (case owner-type
    :escrow-account.owner-type/business
    (business-model/format-name owner lang)
    :escrow-account.owner-type/user
    (if owner
      (user-model/full-name owner)
      (-> account :task/_reference first :task/email))
    ""))

(defn account-number [escrow-account]
  (some-> escrow-account
          (:escrow-account/id (:db/id escrow-account))
          str))

(defmethod group-model/get-authority-group :entity.type/escrow-account
  [escrow-account]
  (:entity/parent escrow-account))
